module.exports = __webpack_public_path__ + "img/social-media.2c51742f.webp";